import { get, post, put, patch, del } from './_httpClient';

export async function getCapacityBuilding({ page = 1, pageSize = 10, batchId = '' } = {}) {
  const params = new URLSearchParams({ page, pageSize });
  if (batchId) {
    params.append('batchId', batchId);
  }
  const { status, message, data } = await get(
    `/clp/capacity-building?${params.toString()}`
  );
  if (status !== 'success') {
    throw new Error(message);
  }
  return data;
}

export async function getCapacityBuildingDetail({ id }) {
  const { status, message, data } = await get(`/clp/capacity-building/${id}`);
  if (status !== 'success') {
    throw new Error(message);
  }
  return data;
}

export async function addCapacityBuilding({ payload }) {
  const responseJson = await post('/clp/capacity-building', payload);
  const { status, message } = responseJson;
  if (status !== 'success') {
    throw new Error(message);
  }
  return responseJson;
}

export async function addQuestionForCapacityBuilding({ id, payload }) {
  const responseJson = await post(`/clp/capacity-building/${id}/test`, payload);
  const { status, message } = responseJson;
  if (status !== 'success') {
    throw new Error(message);
  }
  return responseJson;
}

export async function getTestCapacityBuilding({ id }) {
  const { status, message, data } = await get(`/clp/capacity-building/${id}/test`);
  if (status !== 'success') {
    throw new Error(message);
  }
  return data;
}

export async function getTestQuestionCapacityBuilding({ id, testId }) {
  const { status, message, data } = await get(`/clp/capacity-building/${id}/test/${testId}`);
  if (status !== 'success') {
    throw new Error(message);
  }
  return data;
}

export async function submitTestCapacityBuilding({ id, testId, payload }) {
  const { status, message, data } = await post(
    `/clp/capacity-building/${id}/test/${testId}/submit`,
    payload
  );
  if (status !== 'success') {
    throw new Error(message);
  }
  return data;
}

export async function getAnalyticsCapacityBuildingImprovementKnowledge({ id }) {
  const { status, message, data } = await get(
    `/clp/capacity-building/${id}/analytics/improvement-knowledge`
  );
  if (status !== 'success') {
    throw new Error(message);
  }
  return data;
}

export async function submitAssignmentCapacityBuilding({ id, assignmentId, payload }) {
  const { status, message, data } = await post(
    `/clp/capacity-building/${id}/assignments/${assignmentId}/submit`,
    payload
  );
  if (status !== 'success') {
    throw new Error(message);
  }
  return data;
}

export async function updateCapacityBuilding({ id, payload }) {
  const responseJson = await put(`/clp/capacity-building/${id}`, payload);
  const { status, message } = responseJson;
  if (status !== 'success') {
    throw new Error(message);
  }
  return responseJson;
}

export async function getTaskById({ taskId }) {
  const { status, message, data } = await get(`/clp/capacity-building/tasks/${taskId}`);
  if (status !== 'success') {
    throw new Error(message);
  }
  return data;
}

export async function updateTask({ taskId, payload }) {
  const responseJson = await put(`/clp/capacity-building/tasks/${taskId}`, payload);
  const { status, message } = responseJson;
  if (status !== 'success') {
    throw new Error(message);
  }
  return responseJson;
}

export async function deleteTask({ taskId }) {
  const responseJson = await del(`/clp/capacity-building/tasks/${taskId}`);
  const { status, message } = responseJson;
  if (status !== 'success') {
    throw new Error(message);
  }
  return responseJson;
}

export async function getTestById({ testId }) {
  const { status, message, data } = await get(`/clp/capacity-building/tests/${testId}`);
  if (status !== 'success') {
    throw new Error(message);
  }
  return data;
}

export async function updateTest({ testId, payload }) {
  const responseJson = await put(`/clp/capacity-building/tests/${testId}`, payload);
  const { status, message } = responseJson;
  if (status !== 'success') {
    throw new Error(message);
  }
  return responseJson;
}

export async function deleteTest({ testId }) {
  const responseJson = await del(`/clp/capacity-building/tests/${testId}`);
  const { status, message } = responseJson;
  if (status !== 'success') {
    throw new Error(message);
  }
  return responseJson;
}

export async function addCapacityBuildingMaterial({ id, payload }) {
  const responseJson = await post(`/clp/capacity-building/${id}/materials`, payload);
  const { status, message } = responseJson;
  if (status !== 'success') {
    throw new Error(message);
  }
  return responseJson;
}

export async function deleteCapacityBuildingMaterial({ id, materialId }) {
  const responseJson = await del(`/clp/capacity-building/${id}/materials/${materialId}`);
  const { status, message } = responseJson;
  if (status !== 'success') {
    throw new Error(message);
  }
  return responseJson;
}

export async function gradeTaskSubmission({ submissionId, grade }) {
  const responseJson = await patch(`/clp/capacity-building/submissions/${submissionId}/grade`, { grade });
  const { status, message } = responseJson;
  if (status !== 'success') {
    throw new Error(message);
  }
  return responseJson;
}


